// Primary language tags for those languages we support
export const AVAILABLE_LOCALES = {
  ja: "日本語"
};

// Map from alternative primary language tags to those we support
export const FALLBACK_LOCALES = {
  jp: "ja"
};
